import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Pagetop from '../components/Pagetop/Pagetop';
import Footer from '../components/Footer/Footer';
import Allteams from '../components/Allteams/Allteams';
import Contact from '../components/Contact/Contact';

class Teampage extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="Our Lovely team members" />
                <Pagetop title="Our team members"/>
                <Allteams/>
                <Contact/>
                <Footer/>
            </div>
        );
    }
}

export default Teampage;